<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login"
       v-if="!$store.state.isLoading">
    <div class="main-container">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center">

            <div class="vx-col w-1/2 p-3">
              <img src="@/assets/images/pages/login.gif" alt="login" class="w-100 mx-auto login-gif">
            </div>

            <div class="vx-col w-1/2 ">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4 text-center">
                  <h4 class="mb-4 login-title">Login</h4>
                  <p class="login-subtitle">If you’re an Embiber please use Google sign in</p>
                  <div class="justify-center d-flex mt-4 mb-8">
                    <a style="height:50px;width:250px;" class="abcRioButton abcRioButtonBlue"
                       :href="`${$store.state.appUrl}/connect/google`">
                      <div class="abcRioButtonContentWrapper">
                        <div class="abcRioButtonIcon" style="padding:15px">
                          <div style="width:18px;height:18px;"
                               class="abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                 width="18px" height="18px" viewBox="0 0 48 48"
                                 class="abcRioButtonSvg">
                              <g>
                                <path fill="#EA4335"
                                      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                                <path fill="#4285F4"
                                      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                                <path fill="#FBBC05"
                                      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                                <path fill="#34A853"
                                      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                                <path fill="none" d="M0 0h48v48H0z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <span style="font-size:16px; line-height:48px;"
                              class="abcRioButtonContents">
                                                    <span>Sign in with Google</span>
                                                </span>
                      </div>
                    </a>
                  </div>
                  <p class="login-subtitle">Or login with email credentials shared with you</p>
                </div>
                <div class="login-form">
                  <div class="login-row">
<!--                    <div class="login-label">Email</div>-->
                    <div class="relative">
                      <img src="@/assets/images/pages/login/login.svg" alt="login" class="input-icon">
                    <vs-input
                      @keyup.enter.native="submitForm('loginForm')"
                      type="email"
                      placeholder="Enter your email"
                      v-model="login.email">
                    </vs-input>
                    </div>
                  </div>
                  <div class="login-row">
<!--                    <div class="login-label">Password</div>-->
                    <div class="relative">
                      <img src="@/assets/images/pages/login/pass.svg" alt="login" class="input-icon">
                      <vs-input
                      @keyup.enter.native="submitForm('loginForm')"
                      type="password"
                      placeholder="Enter your password"
                      v-model="login.password">
                    </vs-input>
                    </div>
                  </div>
                  <div class="login-row">
                    <vs-button class="mb-6" type="gradient" id="add-variant-save-btn"
                               @click="submitForm('loginForm')"
                               style="background: #0000B7 !important; width: 230px">Login
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>

export default {
  data: () => ({
    login: {
      email: "",
      password: "",
    }
  }),
  mounted() {
    if (localStorage.getItem('jwt')) {
      this.$router.push({path: '/'})
    }
  },
  methods: {
    submitForm(formName) {
      this.$axios.post(this.$store.state.appUrl + '/auth/local', {
        identifier: this.login.email.toLowerCase(),
        password: this.login.password
      }).then((res) => {
        if (res.data && res.data.jwt && res.data.user) {
          localStorage.setItem("jwt", res.data.jwt);
          this.$store.commit("setState", {user: res.data.user});
          this.$axios.defaults.headers["Authorization"] = "Bearer " + res.data.jwt;
          if (/us/i.test(res.data.user.email)) {
            this.$router.push("/global-search-lm");
          }else if (res.data.user.role === "Authenticated") {
            this.$router.push("/global-search");
          } else {
            // this.$router.push(localStorage.getItem('loginRedirect') || "/");
            this.$router.push("/");
          }
          localStorage.removeItem('loginRedirect');
        } else {
          this.$router.push("/login")
        }
      }).catch(err => {
        this.$vs.notifyWrapper({
          color: 'danger',
          fixed: true,
          title: 'The credentials you have entered is invalid, please try again.',
          time: 5000
        });
      });
    }
  }

}
</script>

<style lang="scss">
.h-screen {
  overflow: auto;
}

.main-container {
  width: 1350px;
  max-width: calc(100% - 20px);
}
.login-title {
  font-size: 24px;
}
.login-subtitle {
  font-size: 14px;
}
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.vs-con-input-label {
  width: 230px;
  margin-bottom: 10px;
}
.full-page-bg-color {
  background: white !important;
  border-radius: 12px;
  overflow: hidden;
}
.login-gif {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
.login-row input.vs-input--input.normal {
  border: 1px solid #999999 !important;
  padding-left: 40px !important;
}
.login-row .vs-input--placeholder.normal {
  padding-left: 40px !important;
}
.input-icon {
  position: absolute;
  top: 50%;
  left: 7px;
  transform: translateY(-50%);
  z-index: 10;
}
#add-variant-save-btn.isActive .vs-button-text.vs-button--text {
  color: white !important;
}
</style>
